module.exports = __webpack_public_path__ + "static/media/2021_4G8A8465.b24c13ed.jpg";